import { BaseClient } from "../../clients/base/BaseClient";
import { FILTERS_ENDPOINTS } from "./filters.consts";
import type { FilterLocation, FilterSampleType, FilterVisitType, FilterRequester, FilterDoctor } from "./filters.types";

/**
 * Filters API Client
 * Handles all filter-related API operations.
 */
export class FiltersClient extends BaseClient {
  /**
   * Fetch locations and instruments.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<FilterLocation[]>} Array of locations with instruments.
   */
  async fetchLocations(signal?: AbortSignal | null): Promise<FilterLocation[]> {
    return this.get<FilterLocation[]>(FILTERS_ENDPOINTS.LOCATIONS, {
      signal,
    });
  }

  /**
   * Fetch sample types.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<FilterSampleType[]>} Array of sample types.
   */
  async fetchSampleTypes(signal?: AbortSignal | null): Promise<FilterSampleType[]> {
    return this.get<FilterSampleType[]>(FILTERS_ENDPOINTS.SAMPLE_TYPES, {
      signal,
    });
  }

  /**
   * Fetch visit types.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<FilterVisitType[]>} Array of visit types.
   */
  async fetchVisitTypes(signal?: AbortSignal | null): Promise<FilterVisitType[]> {
    return this.get<FilterVisitType[]>(FILTERS_ENDPOINTS.VISIT_TYPES, {
      signal,
    });
  }

  /**
   * Fetch requesters.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<FilterRequester[]>} Array of requesters.
   */
  async fetchRequesters(signal?: AbortSignal | null): Promise<FilterRequester[]> {
    return this.get<FilterRequester[]>(FILTERS_ENDPOINTS.REQUESTERS, {
      signal,
    });
  }

  /**
   * Fetch ordering doctors.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<FilterDoctor[]>} Array of doctors.
   */
  async fetchDoctors(signal?: AbortSignal | null): Promise<FilterDoctor[]> {
    return this.get<FilterDoctor[]>(FILTERS_ENDPOINTS.DOCTORS, {
      signal,
    });
  }
}
